<template>
  <span v-if="status === 'up_to_date'"
    :class="['bg-green-100 text-green-700 ring-green-600/20', defaultClasses]">{{ $gettext("À jour") }}</span>
  <span v-else-if="status === 'needs_update'"
    :class="['bg-amber-100 text-amber-700 ring-amber-600/20', defaultClasses]">{{ $gettext("À mettre à jour") }}</span>
  <span v-else
    :class="['bg-gray-100 text-gray-500 ring-gray-500/20', defaultClasses]">{{ $gettext("Révision manuelle") }}</span>
</template>

<script setup>
defineProps({
  status: String,
});

const defaultClasses = "inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset";
</script>
